import type { ConditionalItems, WizardWithConditional } from '@lemonade-hq/chat-wizard-common-definitions';
import type { GenericSchemaDataValue } from '@lemonade-hq/maschema-schema';
import type { RequireOnlyOne, Seconds } from '@lemonade-hq/ts-helpers';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export const OTP_REACHED_MAX_RETRIES = 'OTP_REACHED_MAX_RETRIES';
export const OTP_WENT_BACK = 'OTP_WENT_BACK';

export type SupportedDigits = 6;

export interface TroubleshootByFixingPhoneNumber {
  readonly type: 'fix_phone_number';
  readonly actionCaption?: string;
}

export interface TroubleshootBySkipping extends Partial<WizardWithConditional> {
  readonly type: 'skip';
  readonly actionCaption: string;
  readonly valuesToInclude?: Record<string, GenericSchemaDataValue>;
}

export interface TroubleshootByResend {
  readonly type: 'resend';
  readonly resendUrl: string;
  readonly actionCaption: string;
  readonly countdown?: Seconds;
  readonly valuesToInclude?: Record<string, GenericSchemaDataValue>;
}

export type OtpProps = Otp & RequireOnlyOne<VerificationProps, 'email' | 'userPublicId'>;

export type TroubleshootMethod = TroubleshootByFixingPhoneNumber | TroubleshootByResend | TroubleshootBySkipping;

export interface Otp extends Partial<WizardWithConditional>, UniclientBaseComponentProps {
  readonly digits?: SupportedDigits;
  readonly verifyUrl: string;
  readonly phoneVerification?: boolean;
  readonly troubleshootMethod: ConditionalItems<TroubleshootMethod> | TroubleshootMethod;
  readonly sessionId: string;
  readonly maxRetries?: number;
}

export interface VerificationProps {
  readonly userPublicId: string;
  readonly email: string;
}

export type WizardOtpProps = OtpProps & UniclientWizardComponentBase<'otp'>;

export function otp(props: OtpProps): WizardOtpProps {
  return { ...props, type: 'otp' };
}

export function troubleshootByFixingPhoneNumber(
  props: Omit<TroubleshootByFixingPhoneNumber, 'type'>,
): TroubleshootByFixingPhoneNumber {
  return { ...props, type: 'fix_phone_number' };
}

export function troubleshootBySkipping(props: Omit<TroubleshootBySkipping, 'type'>): TroubleshootBySkipping {
  return { ...props, type: 'skip' };
}

export function troubleshootByResend(props: Omit<TroubleshootByResend, 'type'>): TroubleshootByResend {
  return { ...props, type: 'resend' };
}
